"use client";

import styles from "./styles.module.css";
import { Breadcrumbs } from "../_components/Breadcrumps";
import { usePathname } from "next/navigation";
 
export default function ServicesLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const routes = pathname
    .split("/")
    .slice(1)
    .filter((path) => path.length > 0);
  const lastRoute = routes.at(-1) || "default";

  return (
    <>
      <Breadcrumbs className={styles.breadcrumps} />
      <main className={styles.main}>{children}</main>
    </>
  );

}
